import { render, staticRenderFns } from "./5-FeaturesInfo.vue?vue&type=template&id=0c5841f2&"
import script from "./5-FeaturesInfo.vue?vue&type=script&lang=js&"
export * from "./5-FeaturesInfo.vue?vue&type=script&lang=js&"
import style0 from "./5-FeaturesInfo.vue?vue&type=style&index=0&lang=less&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./5-FeaturesInfo.vue?vue&type=style&index=0&lang=less&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./5-FeaturesInfo.vue?vue&type=style&index=0&lang=less&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("0c5841f2")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5841f2')) {
      api.createRecord('0c5841f2', component.options)
    } else {
      api.reload('0c5841f2', component.options)
    }
    module.hot.accept("./5-FeaturesInfo.vue?vue&type=template&id=0c5841f2&", function () {
      api.rerender('0c5841f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/onboarding/components/registrationSteps/5-FeaturesInfo.vue"
export default component.exports